module.exports = __webpack_public_path__ + "img/Logo(ko)_Dark.3da698b6.svg";